export default "__VITE_ASSET__CdprKyR7__"